import CustomToggle from 'Common/CustomToggle'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import api from 'http'
import OTPVerificationPopup from 'Popups/PatientProfilePicPopup/OTPVerificationPopup'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'react-tooltip'
import { LuMail, LuSmartphone, LuKey } from 'react-icons/lu'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'

const MFA = () => {
    const [selectedValue, setSelectedValue] = useState({
        email: false,
        text: false,
        authenticator: false
    })
    const [showOtpPopup, setShowOtpPopup] = useState({ status: false, data: null })
    const [state, setState] = useState({
        email: "",
        emailStatus: "Un-Verified",
        message: "",
        phoneNumber: null,
        phoneNumberStatus: "Un-Verified",
    })
    const [loader, setLoader] = useState(false)

    const { userinfo } = useSelector((state) => state.userAuth);



    const handleSelectedValueChange = async (e) => {
        setShowOtpPopup({
            status: true,
            data: { transferVia: e.target.name, enableMFA: !e.target.checked }
        })
    }

    const onCloseOtpVerificationPopup = () => {
        setShowOtpPopup({ status: false, data: null })
    }
    useEffect(() => {
        (async () => {
            try {
                setLoader(true)
                const response = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/TwoFactorAuthentication/Ensure2FAContactVerified/false`,);
                setState(response.data.dataModel)
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setLoader(false)
            }
        })();
        setSelectedValue({
            email: userinfo.twoFactorViaEmail,
            text: userinfo.twoFactorViaText,
            authenticator: userinfo.twoFactorViaAuthenticator,
        });
    }, [userinfo])
    return (
        <div>
            {loader && <FullPageLoader allowFullScreen />}
            {showOtpPopup.status && <OTPVerificationPopup data={showOtpPopup.data} transferVia={showOtpPopup.data.transferVia} enableMFA={showOtpPopup.data.enableMFA} onClose={onCloseOtpVerificationPopup} />}
            
            <Tooltip place="top" id="phone_validation_tooltip" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <label className="flex flex-col p-5 border border-gray-200 rounded-lg bg-white  hover:border-primary2 hover:bg-gray-50/50 transition-colors">
                    <div className="flex items-start justify-between -mt-1 -mr-1 -ml-1">
                        <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 border border-green-200 rounded">Verified</span>
                        <CustomToggle name="email" checked={selectedValue.email} onChange={handleSelectedValueChange} />
                    </div>
                    <div className="flex flex-col items-center text-center">
                        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-brand-50 mb-3">
                            <LuMail className="w-7 h-7 text-primary2" />
                        </div>
                        <h4 className="text-sm font-medium text-gray-900">Email</h4>
                        <p className="text-sm text-gray-500 mt-2">Secure your account by verifying your identity through a one-time code sent to your registered email.</p>
                    </div>
                </label>
                <label className="flex flex-col p-5 border border-gray-200 rounded-lg bg-white  hover:border-primary2 hover:bg-gray-50/50 transition-colors" data-tooltip-id="phone_validation_tooltip" data-tooltip-content={!state.phoneNumber ? state.message : ''}>
                    <div className="flex items-start justify-between -mt-1 -mr-1 -ml-1">
                        <span className={`px-2 py-0.5 text-xs font-medium rounded border ${state.phoneNumberStatus === 'Verified' ? 'text-green-700 bg-green-100 border-green-200' : 'text-red-700 bg-red-100 border-red-200'}`}>{state.phoneNumberStatus}</span>
                        <CustomToggle name="text" checked={selectedValue.text} onChange={handleSelectedValueChange} disabled={!state.phoneNumber} />
                    </div>
                    <div className="flex flex-col items-center text-center">
                        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-brand-50 mb-3">
                            <LuSmartphone className="w-7 h-7 text-primary2" />
                        </div>
                        <h4 className="text-sm font-medium text-gray-900">Phone</h4>
                        <p className="text-sm text-gray-500 mt-2">Enhance security with a one-time code sent to your registered phone number for identity verification.</p>
                    </div>
                </label>
                <label className="flex flex-col p-5 border border-gray-200 rounded-lg bg-white  hover:border-primary2 hover:bg-gray-50/50 transition-colors">
                    <div className="flex items-start justify-between -mt-1 -mr-1 -ml-1">
                        <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 border border-green-200 rounded">Verified</span>
                        <CustomToggle name="authenticator" checked={selectedValue.authenticator} onChange={handleSelectedValueChange} />
                    </div>
                    <div className="flex flex-col items-center text-center">
                        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-brand-50 mb-3">
                            <LuKey className="w-7 h-7 text-primary2" />
                        </div>
                        <h4 className="text-sm font-medium text-gray-900">Authenticator</h4>
                        <p className="text-sm text-gray-500 mt-2">Protect your account using a time-based one-time code generated in the Google Authenticator app.</p>
                    </div>
                </label>
            </div>
        </div>
    )
}

export default MFA